import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "./SEO";

export default function PaymentInfo() {
  return (
    <div className="app">
      <SEO
        title="Način plaćanja - TraveLina"
        description="Način plaćanja paket aranžmana i uvjeti plaćanja."
        keywords="način plaćanja, avans 40%, bankovno plaćanje, TraveLina"
      />
      <Navbar />
      <main>
        <section className="section" style={{ paddingTop: "6rem" }}>
          <div className="container">
            <article>
              <h1 style={{ marginBottom: "2rem", color: "#f97316", fontSize: "2rem" }}>
                Način plaćanja
              </h1>
              <div
                style={{
                  padding: "2rem",
                  background: "#fafafa",
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(0, 0, 0, 0.08)",
                  fontSize: "0.95rem",
                  lineHeight: "1.8",
                  color: "#111827",
                  whiteSpace: "pre-wrap",
                }}
              >
                {`Plaćanje paket-aranžmana vrši se isključivo bankovnom uplatom.

Uvjeti plaćanja:
1) Avans 40% ukupnog iznosa aranžmana po osobi plaća se prilikom potvrde rezervacije.
2) Ostatak iznosa plaća se najkasnije 10 dana prije polaska (ako u programu nije drukčije navedeno).

Podaci za uplatu:
IBAN: HR7523400093207336956
Primatelj: Obrt KOD DEDE I FLOKIJA, VL. LINA SKENDER
Opis plaćanja: Ime i prezime putnika + naziv putovanja

Važne napomene:
- Rezervacija se smatra potvrđenom tek po vidljivoj uplati avansa.
- U slučaju neplaćenog ostatka u propisanom roku, organizator može otkazati rezervaciju.
- Sve potvrde uplata preporučujemo poslati na email radi brže evidencije.

Kontakt za potvrdu uplata:
Email: info@linatravelina.eu
Telefon: +385 91 214 4477`}
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
